export default {"src":"/_next/static/media/nextJS.99e26750.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};